import { createModel } from '@rematch/core'
import * as firebase from 'firebase'

interface IStatsState {
  [lectureId: string]: IStats
}

const errorStats: IStats = {
  replyIds: [],
  insightIds: [],
  materialMetas: [],
}

export default createModel({
  state: {} as IStatsState,
  reducers: {
    updateById: (state: IStatsState, payload: { lectureId: string, stats: IStats }): IStatsState => ({
      ...state, [payload.lectureId]: payload.stats
    }),
  },
  effects: {
    async fetchStats(lectureId: string) {
      const getStats = firebase.functions().httpsCallable('stats-getStats')
      getStats({ lectureId })
        .then(res => this.updateById({ lectureId, stats: res.data }))
        .catch(error => this.updateById({ lectureId, errorStats }))
    },
  },
  selectors: {
    getById: (state: IStatsState, statsId: string) => {
      return state[statsId] ? state[statsId] : null
    },
  }
})


// WEBPACK FOOTER //
// ./src/models/stats.ts